module.exports = __webpack_public_path__ + "fonts/Renault-Global.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/icons/Renault-Global.ttf
// module id = 369
// module chunks = 0